<template>
  <section id="video-section">
    <div id="video-section__bg" />
    <b-container id="video-section__content">
      <h2>É simples, é fácil, é Ciclic!</h2>
      <p>
        Não existe segredo na hora de contratar ou utilizar a proteção Ciclic! <br />
        Veja nossos vídeos e tire suas principais dúvidas em instantes.
      </p>

      <div id="video-section__content__frames">
        <PlayerBox v-for="video in videos" :key="video.title" :info="video" />
      </div>
    </b-container>
  </section>
</template>

<script>
import PlayerBox from './PlayerBox'

export default {
  name: 'VideoSection',
  components: {
    PlayerBox
  },
  data () {
    return {
      videos: [
        { id: 'yZ_PzslOVik', title: 'Como contratar o Seguro Celular', thumbnail: 'how_to_hire' },
        { id: 'F-xz6TxuySs', title: 'Como acionar o seu Seguro Celular', thumbnail: 'how_to_trigger' }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
#video-section {
  padding: 80px 0;
  position: relative;

  &__bg {
    background: #F4F4F4;
    height: 394px;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
    z-index: -1;
  }

  &__content {
    z-index: 2;

    h2 {
      color: #1D2C53;
      font-family: Oscine, sans-serif;
      font-style: normal;
      font-weight: bold;
      font-size: 40px;
      line-height: 50px;
      text-align: center;
      margin-bottom: 16px;
    }

    p {
      color: #1D2C53;
      font-family: Rubik, sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 22px;
      text-align: center;
      margin-bottom: 32px;
    }

    &__frames {
      display: grid;
      grid-template-columns: 1fr;
      gap: 32px 32px;

      @media (min-width: 890px) {
        grid-template-columns: repeat(2, 1fr);
      }
    }
  }
}
</style>
